
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 426.7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#009543","d":"M0 293h640v133.7H0V293z"}}),_c('path',{attrs:{"fill":"#ED4135","d":"M0 132h640v161.3H0V132z"}}),_c('path',{attrs:{"fill":"#0035AD","d":"M0 0h640v133.3H0V0z"}}),_c('circle',{attrs:{"fill":"#FAE600","stroke":"#000","stroke-width":"5.3","cx":"240","cy":"213.3","r":"157.3"}}),_c('path',{attrs:{"d":"M307.9 354.5l-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"}}),_c('path',{attrs:{"d":"M212.727 102.375l42.955-21.418 5.577 11.187-42.955 21.417z"}}),_c('ellipse',{attrs:{"cx":"237.8","cy":"280.5","rx":"16.8","ry":"26.5"}}),_c('circle',{attrs:{"cx":"237.4","cy":"143.4","r":"20.9"}}),_c('ellipse',{attrs:{"cx":"238.4","cy":"211.1","rx":"19.9","ry":"12.1"}}),_c('path',{attrs:{"d":"M213.8 177h47v10h-47zM213.8 234h47v10h-47z"}})])
          )
        }
      }
    